import Logo from "./Logo";

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer py-2 has-background-white-ter py-6" style={{ borderTop: "1px solid #e5e7eb"}}>
      <div className="container mx-auto is-max-desktop">
        <div className="fixed-grid has-2-cols-tablet has-12-cols-desktop">
            <div className="grid mb-4">
            <div className="cell">
                <Logo />
                <p className="has-text-grey has-text-justified is-unselectable" style={{maxWidth: "28rem"}}>
                    The complete DevOps platform for zero-knowledge proof systems. 
                    Build, benchmark, and deploy ZK circuits with confidence.
                </p>
            </div>


            <div className="cell has-text-right-mobile">
                <h3 className="has-text-weight-medium mb-4">Company</h3>
                <ul className="">
                <li>
                    <a href="mailto:team@nargklab.com" className="has-text-black-bis">Contact</a>
                </li>
                </ul>
            </div>
            </div>
        </div>

        <div className="pt-4" style={{borderTop: "1px solid #e5e7eb"}}>
          <div className="">
            <p className="has-text-text-60 is-size-6">
              © {currentYear} nargklab. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
